import { AxiosInstance } from "axios";

export const deleteRiskTheme = async (
  axiosInstance: AxiosInstance,
  id: number | string | undefined
) => {
  return await axiosInstance.delete(`/rest/risk/v1/delete/${id}`);
};

export const deleteControl = async (
  axiosInstance: AxiosInstance,
  id: number | string | undefined
) => {
  return await axiosInstance.delete(`/rest/risk-item/v1/delete/${id}`);
};

export const deleteHistoryControl = async (
  axiosInstance: AxiosInstance,
  id: number
) => {
  return await axiosInstance.delete(
    `/rest/risk-item-evolution/v1/delete/${id}`
  );
};

export const deleteCollaborator = async (
  axiosInstance: AxiosInstance,
  id: number
) => {
  return await axiosInstance.delete(`/rest/collaborator/v1/delete/${id}`);
};

export const deleteTag = async (
  axiosInstance: AxiosInstance,
  tagId: number
) => {
  return await axiosInstance.delete(`/rest/tags/${tagId}`);
};
